import { render, staticRenderFns } from "./Wizard-Basic.vue?vue&type=template&id=213689de&scoped=true"
import script from "./Wizard-Basic.vue?vue&type=script&lang=js"
export * from "./Wizard-Basic.vue?vue&type=script&lang=js"
import style0 from "./Wizard-Basic.vue?vue&type=style&index=0&id=213689de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213689de",
  null
  
)

export default component.exports